export const environment = {
  production: true,
  googleClientId: '750784711285-rhffc8uejm9bqscm9hikns8rb9qok493.apps.googleusercontent.com'
};
